<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->

    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Teacher Marks Entry Extension</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>

        <v-row justify="center" dense>
          <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
            <v-radio label="Assessment Type Wise" value="assessmenttype" color="#0f2027"
              @change="dates_list = []"></v-radio>
            <v-radio label="Semester Wise" value="semester" color="#0f2027" @change="dates_list = []"></v-radio>
          </v-radio-group>
        </v-row>
        <v-row justify="center" dense v-if="radios == 'assessmenttype'">
          <v-col cols="12" sm="3" md="3">
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list"
              item-text="name" item-value="id" label="Employee" outlined persistent-hint
              hint="Please Select Employee" />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-autocomplete color="#0F2027" dense rounded required v-model="assessmenttype" :items="assessmenttype_list"
              item-text="name" item-value="id" label="Assessment Type" outlined persistent-hint
              hint="Please Select Assessment Type" />
          </v-col>
          <v-col cols="12" sm="1" md="1">
            <v-btn color="warning" @click="getCOI()" :loading="loader">Fetch</v-btn>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="radios == 'semester'">
          <v-col cols="12" sm="3" md="3">
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list"
              item-text="name" item-value="id" label="Employee" outlined persistent-hint
              hint="Please Select Employee" />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-autocomplete color="#0F2027" dense rounded required v-model="semester" :items="semester_list"
              item-text="sem" item-value="id" label="Semester" outlined persistent-hint hint="Please Select Semester" />
          </v-col>
          <v-col cols="12" sm="1" md="1">
            <v-btn color="warning" @click="getCOI()" :loading="loader">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="coi_list!=''" dense>
        <v-data-table :headers="headers" :items="coi_list" dense>
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Subjects List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.edit`]="{item}">
            <v-btn small color="warning" @click="updateDueDate(item)">Proceed</v-btn>
          </template>
        </v-data-table>
      </v-card>

      <span v-if="radios == 'assessmenttype'">
        <v-card class="box" v-if="dates_list!=''" dense>
          <v-data-table :headers="headers_2" :items="dates_list" dense>
            <template v-slot:top>
              <v-toolbar flat class="toolbar">
                <v-toolbar-title>Extended List Assessment Type Wise</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card>
      </span>
      <span v-if="radios == 'semester'">
        <v-card class="box" v-if="dates_list!=''" dense>
          <v-data-table :headers="headers_3" :items="dates_list" dense>
            <template v-slot:top>
              <v-toolbar flat class="toolbar">
                <v-toolbar-title>Extended List Semester Wise</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card>
      </span>

      <v-dialog v-model="dialog" max-width="800px">
        <v-card>
          <v-col cols="12" sm="12" md="12">
            <v-card class="box">
              <v-row justify="center" dense>
                <v-col cols="12" sm="6" md="6">
                  <p><b>Extend Marks Entry Date</b></p>
                  <v-text-field v-model="date_edit" rounded outlined dense prepend-icon="mdi-calendar"
                    type="date"></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center" dense>
                <v-col cols="12" sm="6" md="6">
                  <p><b>Description</b></p>
                  <v-textarea outlined name="input-7-4" v-model="description" label="Enter Description"></v-textarea>

                </v-col>
              </v-row>
              <v-row justify="center" dense>
                <v-btn class="button" @click="saveDueDate()" :loading="loader">Save</v-btn>
                <v-btn class="button" @click="dialog = false">Close</v-btn>
              </v-row>
            </v-card>
          </v-col>
        </v-card>
      </v-dialog>
    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed


export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      radios:null,
      loader:false,
      snackbar_msg: "",
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      color: "",
      snackbar: false,
      overlay: false,
      ay_list:[],
      employee_list:[],employee:[],dialog:false,date_edit:new Date().toISOString().substr(0, 10),
      assessmenttype_list:[],assessmenttype:"",coi_list:[],description:"",coi_id:"",dates_list:[],semester_list:[],semester:"",
      ay:"",
      headers:[
      { text: "SR no", value: "srno" },
      { text: "Course", value: "crs_name" },
      { text: "Standard", value: "standard" },
      { text: "Division", value: "divisionoffering" },
      { text: "Edit", value: "edit" },
      ],
      headers_2:[
      { text: "SR no", value: "srno" },
      { text: "Course", value: "crs_name" },
      { text: "Teacher", value: "teacher" },
      { text: "Assessment Type", value: "assessmenttype" },
      { text: "Extended Date", value: "due_date" },
      { text: "Description", value: "description" },
      { text: "Standard", value: "standard" },
      { text: "Division", value: "division" },
      ],
       headers_3:[
      { text: "SR no", value: "srno" },
      { text: "Course", value: "crs_name" },
      { text: "Teacher", value: "teacher" },
      { text: "Semester", value: "semester" },
      { text: "Extended Date", value: "due_date" },
      { text: "Description", value: "description" },
      { text: "Standard", value: "standard" },
      { text: "Division", value: "division" },
      ],
  }),
   methods: {
    async updateDueDate(item){
      try {
        this.loader=true
        this.overlay=true
         const data = {
            coi:item.id,
            assessmenttype:this.assessmenttype,
        };
        this.overlay = true;
          const res = await axios.post("/WWSExamination/getDateInfo", data);
          if (res.data.flag == "YES") {
              this.date_edit=res.data.due_date_edit
              this.description=res.data.description
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
            this.loader = false;
            this.overlay = false;
            this.coi_id=item.id
            this.dialog=true
      }
    },
     async saveDueDate() {
      try {
        this.loader=true
        this.overlay=true
         const data = {
            ay:this.ay,
            employee:this.employee,
            assessmenttype:this.assessmenttype,
            description:this.description,
            date_edit:this.date_edit,
            coi:this.coi_id,
            radios:this.radios,
            semester:this.semester
        };
        this.overlay = true;
          const res = await axios.post("/WWSExamination/saveExtendDueDate", data);
          if (res.data.flag == "YES") {
                this.showSnackbar("green", "Saved Successfully..."); // show snackbar
                this.dialog=false
                this.dates_list=res.data.dates_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
            this.loader = false;
            this.overlay = false;
      }
     
    },
    onLoad() {
        this.overlay=true
        axios
            .post("WWSExamination/teacherMarksEntryExtension")
            .then((res) => {
                if (res.data.flag == "YES") {
                    this.ay_list = res.data.ay_list;
                    this.ay = res.data.cay;
                    this.assessmenttype_list = res.data.assessmenttype_list;
                    this.employee_list = res.data.employee_list;
                    this.semester_list = res.data.semester_list;
                    this.overlay = false;
                } else {
                    this.showSnackbar("#b71c1c", res.data.status_reason);
                }
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                this.overlay = false;
            })
            .finally(() => {
                this.overlay = false;
            });
            },
    async getCOI() {
      try {
        this.loader=true
        this.overlay=true
         const data = {
            ay:this.ay,
            employee:this.employee,
            assessmenttype:this.assessmenttype,
            radios:this.radios,
            semester:this.semester
        };
        this.overlay = true;
          const res = await axios.post("/WWSExamination/getCOI", data);
          if (res.data.flag == "YES") {
                 this.coi_list=res.data.coi_list
                 this.dates_list=res.data.dates_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
            this.loader = false;
            this.overlay = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>